export const useParamQuery = () => {
	const url = window.location.search
	const location = new URLSearchParams(url)

	return { params: location }
}
